@if (label()) {
  <label class="text-primary fw-bold">{{ label() | translate }}</label>
}

<mat-slider [min]="min()" [max]="max()" [step]="step()" class="w-100 m-0">
  <input matSliderStartThumb [value]="controlValue[0]" (input)="updateValue([+$event.target.value, controlValue[1]])" />
  <input matSliderEndThumb [value]="controlValue[1]" (input)="updateValue([controlValue[0], +$event.target.value])" />
</mat-slider>

<div class="d-flex justify-content-between text-primary font-14 fw-bold">
  <span class="d-flex align-items-end gap-2 fw-bold">
    <span class="font-16 currency">{{ controlValue[0] }}</span>

    @if (unitRef()) {
      <ng-container [ngTemplateOutlet]="unitRef()!" />
    } @else {
      {{ unit() | translate }}
    }
  </span>

  <span class="d-flex align-items-end gap-2 fw-bold">
    <span class="font-16 currency">{{ controlValue[1] }}</span>

    @if (unitRef()) {
      <ng-container [ngTemplateOutlet]="unitRef()!" />
    } @else {
      {{ unit() | translate }}
    }
  </span>
</div>
